import Api from "./Api";
import store from "@/store";

class CompanyApi extends Api {
  constructor(version = "public/v2") {
    super(version);
    this.path = "companies";
  }

  allAutocomplete(params) {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.path, { params })
        .then(response => {
          resolve(response.data.resources);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  async getCompany(params) {
    let response = await this.http.get("companies/" + params);
    return response.data.resource;
  }

  async updateCompany(id, params) {
    let response = await this.http.put(`companies/${id}`, params);

    if (response.status === 201) {
      store.commit("SET_NOTIFICATION", {
        title: "ui.company.actions.success",
        type: "success"
      });
    } else {
      store.commit("SET_NOTIFICATION", {
        title: "ui.company.actions.error",
        type: "error"
      });
    }

    return response.data.resource;
  }

  async createCompany(params) {
    const response = await this.http.post(`companies/`, params);

    if (response.status == 201) {
      store.commit("SET_NOTIFICATION", {
        title: "ui.company.actions.success_create",
        type: "success"
      });
    } else {
      store.commit("SET_NOTIFICATION", {
        title: "ui.company.actions.error_create",
        type: "error"
      });
    }

    return response.data.resource;
  }

  async deleteCompany(params) {
    let response = await this.http.delete("companies/" + params)

    if (response.status === 204) {
      store.commit("SET_NOTIFICATION", {
        title: "ui.company.actions.success_delete",
        type: "success"
      })
    } else {
      store.commit("SET_NOTIFICATION", {
        title: "ui.company.actions.error_delete",
        type: "error"
      })
    }

    return response.status
  }

  getCompanyContact(params) {
    return new Promise((resolve, reject) => {
      this.http
        .get("companies" + "/" + params + "/" + "contacts")
        .then(response => {
          resolve(response.data.resources);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  async getAllCompanies(params = {}) {
    if (params) {
      params = {
        search: params["search"] ? params["search"] : "",
        per_page: params["per_page"] ? params["per_page"] : 5,
        page: params["page"] ? params["page"] : 1,
        sort_by: params["sort_by"] ? params["sort_by"] : "id",
        sort_order: params["sort_order"] ? params["sort_order"] : "ASC"
      };
    }

    let response = await this.http.get("companies", {
      params: params
    });
    return response;
  }

  search(params, searchQuery) {
    if (!params.per_page) {
      params.per_page = this.page_length;
    }
    params.query = searchQuery;
    return new Promise((resolve, reject) => {
      this.http
        .get(this.path + "/search", { params })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }
}
export default CompanyApi;



// WEBPACK FOOTER //
// ./src/api/Company.js